<template>
  <div class="tab">
    <el-footer v-if="$can('update', 'cameras') && camera.is_deleted !== 1" class="tab__footer page__active_bar">
      <el-button
        v-if="$can('update', 'cameras')"
        id="savePushCamera"
        class="page__active_button"
        type="primary"
        :loading="fetch"
        @click="onSubmit"
      >
        Сохранить
      </el-button>
      <el-button
        v-if="$can('delete', 'cameras')"
        class="page__active_button"
        type="danger"
        :loading="fetch"
        @click="onDelete"
      >
        Удалить
      </el-button>
      <template v-if="camera.state !== 'test'">
        <el-button
          v-if="$can('update', 'cameras_state')"
          id="switchOnPushCamera"
          class="page__active_button"
          :type="camera.switch ? 'danger' : 'success'"
          plain
          :loading="fetch"
          @click="onToggle"
        >
          {{ camera.switch ? "Деактивировать" : "Активировать" }}
        </el-button>
      </template>
      <template v-if="camera.is_rrtsp === 1">
        <el-button
          v-if="$can('update', 'cameras_state')"
          class="page__active_button"
          type="info"
          :loading="fetch"
          @click="onReboot"
        >
          Перезагрузить
        </el-button>
      </template>
      <el-button-group v-if="camera.state === 'test' && $can('update', 'cameras_state')" class="page__active_button">
        <el-button type="warning" icon="el-icon-warning-outline" disabled>
          Камера работает в тестовом режиме
        </el-button>
        <template v-if="$can('update', 'cameras_state')">
          <template v-if="camera.is_rrtsp === 1">
            <el-button type="info" :loading="fetch" @click="onReboot">
              Перезагрузить
            </el-button>
          </template>
          <el-button type="success" plain @click="switchCamera(true)">
            Активировать
          </el-button>
          <el-button plain @click="switchCamera(false)">
            Деактивировать
          </el-button>
        </template>
      </el-button-group>
    </el-footer>
    <main class="page_container">
      <el-row justify="space-between" :gutter="20">
        <el-col :span="12">
          <el-alert
            v-if="camera.days_to_deleting"
            :closable="false"
            show-icon
            type="error"
            title="Удаление камеры"
            :description="deleteDescription"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <camera-form
            ref="form"
            :hidden-fields="hiddenFields"
            :request-parameter="requestParameter"
            :get-is-parameter-showed="getIsParameterShowed"
            :reveal-rtsp-fields="revealRtspFields"
          />
        </el-col>
        <el-col :span="12">
          <camera-media ref="cameraMedia" :remove-parameter-from-hidden-fields="removeParameterFromHiddenFields" />
        </el-col>
      </el-row>
    </main>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import CameraForm from "@/components/Cameras/components/Camera/features/CameraForm";
import CameraMedia from "@/components/Cameras/components/Camera/features/CameraMedia";
import { GREY_RTSP_FIELDS } from "@/components/Cameras/components/Camera/greyRtsp";

const DEFAULT_HIDDEN_FIELDS = [
  "stream",
  "login_onvif",
  "password_onvif",
  "move_duration_default",
  "port_onvif",
  "login",
  "password",
  "port",
  "disable_sub_stream",
  "is_return_sldp_links",
  ...GREY_RTSP_FIELDS,
];

export default {
  name: "CameraEdit",
  components: { CameraForm, CameraMedia },
  data() {
    return {
      fetch: false,
      hiddenFields: DEFAULT_HIDDEN_FIELDS,
      /* Промис загрузки RTSP-параметров при переводе камеры на RTSP */
      rtspFieldsPromise: null,
    };
  },
  computed: {
    ...mapState("cameras", {
      camera: (state) => state.camera,
    }),
    deleteDescription() {
      if (!this.camera.days_to_deleting) return "";
      let desc = `Камера будет удалена через ${this.camera.days_to_deleting} `;

      switch (this.camera.days_to_deleting) {
        case 1:
          return (desc += "день");
        case 2:
        case 3:
        case 4:
          return (desc += "дня");
        default:
          return (desc += "дней");
      }
    },
  },
  methods: {
    ...mapActions("cameras", {
      deleteCamera: "DELETE_CAMERA",
      switchOnCamera: "SWITCH_ON_CAMERA",
      switchOffCamera: "SWITCH_OFF_CAMERA",
      rebootCamera: "REBOOT_CAMERA",
      getCameraStream: "GET_CAMERA_STREAM",
      getCameraGreyRtspLink: "GET_CAMERA_GREY_RTSP_LINK",
      getCameraCredentialsOnvif: "GET_CAMERA_CREDENTIALS_ONVIF",
      getCameraCredentials: "GET_CAMERA_CREDENTIALS",
    }),
    ...mapMutations("cameras", {
      setCamera: "SET_CAMERA",
    }),
    resetFields() {
      this.$refs["cameraMedia"].resetMediaFields();
      this.hiddenFields = DEFAULT_HIDDEN_FIELDS;
    },
    revealRtspFields() {
      /* При переводе камеры на RTSP сначала подгружаем текущие RTSP-значения (ссылка либо
         логин/пароль/порт) и только после успешной загрузки снимаем поля с hidden_fields.
         Иначе пустые инпуты затирают данные камеры на бэкенде. */
      const parameter = this.camera.is_created_by_stream_link ? "stream" : "credentials";
      this.rtspFieldsPromise = this.requestParameter(parameter);
      return this.rtspFieldsPromise;
    },
    onDelete() {
      if (this.camera.is_lvs === 1) {
        const serverName = this.camera.lvs_server_name ? ` «${this.camera.lvs_server_name}»` : "";
        this.$message.error(`Камера не удалена. Сперва удалите камеру в LinkVideo.Server${serverName}`);
        return;
      }
      if (this.camera.is_lvb === 1) {
        this.$message.error("Камера не удалена. Сперва удалите камеру в LinkVideo.Bridge");
        return;
      }

      this.$confirm("Вы точно хотите удалить камеру?", "Подтверждение", {
        confirmButtonText: "Удалить",
        type: "warning",
      }).then(() => {
        this.fetch = true;
        this.deleteCamera(this.camera.id_camera)
          .then(() => {
            this.$router.push({ name: "cameras", params: { page: 1 } });
            this.$message({
              message: "Камера успешно удалена",
              type: "success",
            });
          })
          .catch((error) => {
            this.$message.error(error.response?.data?.error || "Произошла ошибка при удалении камеры");
          })
          .finally(() => (this.fetch = false));
      });
    },
    onToggle() {
      return this.switchCamera(!this.camera.switch);
    },
    getIsParameterShowed(parameter) {
      switch (parameter) {
        case "credentials_onvif":
          return !this.hiddenFields.some((field) =>
            ["login_onvif", "password_onvif", "move_duration_default", "port_onvif"].includes(field)
          );
        case "credentials":
          return !this.hiddenFields.some((field) => ["login", "password", "port"].includes(field));
        case "grey_rtsp_settings":
          return !this.hiddenFields.some((field) => GREY_RTSP_FIELDS.includes(field));
        default:
          return !this.hiddenFields.some((field) => field === parameter);
      }
    },
    requestParameter(parameter) {
      const idCamera = this.camera.id_camera;
      let promise;

      switch (parameter) {
        case "stream":
          promise = this.getCameraStream(idCamera);
          break;
        case "grey_rtsp_link":
        case "grey_rtsp_settings":
          promise = this.getCameraGreyRtspLink(idCamera);
          break;
        case "credentials_onvif":
          promise = this.getCameraCredentialsOnvif(idCamera);
          break;
        case "credentials":
          promise = this.getCameraCredentials(idCamera);
          break;
      }

      return Promise.resolve(promise)
        .then(() => {
          this.removeParameterFromHiddenFields(parameter);
        })
        .catch(() => {
          this.$message.error("Не удалось загрузить параметры камеры. Попробуйте ещё раз");
        });
    },
    removeParameterFromHiddenFields(parameter) {
      switch (parameter) {
        case "credentials_onvif":
          this.hiddenFields = this.hiddenFields.filter(
            (field) => !["login_onvif", "password_onvif", "move_duration_default", "port_onvif"].includes(field)
          );
          break;
        case "credentials":
          this.hiddenFields = this.hiddenFields.filter((field) => !["login", "password", "ip", "port"].includes(field));
          break;
        case "stream_data":
          this.hiddenFields = this.hiddenFields.filter(
            (field) => !["disable_sub_stream", "is_return_sldp_links"].includes(field)
          );
          break;
        case "grey_rtsp_settings":
          this.hiddenFields = this.hiddenFields.filter((field) => !GREY_RTSP_FIELDS.includes(field));
          break;
        default:
          this.hiddenFields = this.hiddenFields.filter((field) => field !== parameter);
      }
    },
    switchCamera(newState) {
      this.fetch = true;
      this.resetFields();

      const { id_camera } = this.camera;

      (newState ? this.switchOnCamera(id_camera) : this.switchOffCamera(id_camera))
        .then((camera) => {
          this.$message({
            message: camera.switch ? "Камера активирована" : "Камера деактивирована. Трансляция остановлена",
            type: "success",
          });

          this.setCamera(camera);
        })
        .catch((e) => {
          this.$message.error(
            e.response.data.error || `Произошла обшибка при ${newState ? "активации" : "деактивации"} камеры`
          );
        })
        .finally(() => {
          this.fetch = false;
        });
    },
    onSubmit(e) {
      const form = this.$refs["form"];
      const submit = () => form.submit(e);

      /* При переводе на RTSP не сбрасываем hidden_fields, иначе введённые RTSP-поля не дойдут до бэкенда */
      if (!form.isSwitchingToRtsp()) {
        submit();
        this.resetFields();
        return;
      }

      this.$refs["cameraMedia"].resetMediaFields();

      /* Дожидаемся загрузки RTSP-параметров, чтобы форма ушла с актуальными значениями */
      return Promise.resolve(this.rtspFieldsPromise)
        .then(() => this.$nextTick())
        .then(() => {
          this.rtspFieldsPromise = null;
          submit();
        });
    },
    onReboot() {
      this.fetch = true;

      const { id_camera } = this.camera;

      this.rebootCamera(id_camera)
        .then(() => {
          this.$message({
            message: "Камера перезагружена",
            type: "success",
          });
        })
        .catch((e) => {
          this.$message.error(e.response?.data?.error || "Произошла ошибка при перезагрузке камеры");
        })
        .finally(() => {
          this.fetch = false;
        });
    },
  },
};
</script>
